import { Spacing } from '@persona-id/design-tokens';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';

import FrameTrigger from 'lib/clients/FrameTrigger';

const Wrapper = styled('div')<{ color?: string }>`
  color: ${(props) => (props.color ? props.color : props.theme.colorFont)};
  text-align: center;

  display: flex;
  flex: auto;
  align-items: center;
  justify-content: space-around;

  padding-left: ${Spacing[6]};
  padding-right: ${Spacing[6]};
  height: ${Spacing[8]};
`;

interface HintPromptProps<TriggerType, TriggerParams, Localizations = never> {
  activeTrigger: FrameTrigger<TriggerType, TriggerParams, Localizations>;
  color?: string;
  localizations?: Localizations;
}

export default function HintPrompt<TriggerType, TriggerParams, Localizations = never>({
  activeTrigger,
  color,
  localizations,
}: HintPromptProps<TriggerType, TriggerParams, Localizations>) {
  const [t] = useTranslation();
  return (
    <Wrapper color={color}>
      <p role='alert'>{activeTrigger.getPrompt({ t, localizations })}</p>
    </Wrapper>
  );
}
